export function pathTo(resource) {
  switch (resource.__typename) {
    case 'ContentfulPage':
      return `/${resource.slug}`;
    default:
      return `/${resource.slug}`;
  }
}
